import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { LogoCarousel } from '../components/landing/LogoCarousel';
import { Work } from '../components/landing/Work';
import { Services } from '../components/landing/Services';
import { About } from '../components/landing/About';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full overflow-x-hidden" style={{
    background: 'var(--bg)',
    color: 'var(--fg)'
  }} data-id="element-269">
      <Navbar data-id="element-270" />
      <Hero data-id="element-271" />
      <LogoCarousel data-id="element-272" />
      <Work data-id="element-273" />
      <Services data-id="element-274" />
      <About data-id="element-275" />
      <Footer data-id="element-276" />
    </div>;
}